export const ROUTE_PATHS = {
  ROOT: "/",
  DASHBOARD: "/dashboard",
  DATASEARCH: "/datasearch",
  PROFILE: "/profile",
  PERSONAL_DASHBOARD: "/dashboard/me",
  ACCESS_DENIED: "/access-denied",
};
